var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form',{staticClass:"b-layout",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('text')))]),_c('b-input',{staticClass:"input-pentagro",model:{value:(_vm.node.text),callback:function ($$v) {_vm.$set(_vm.node, "text", $$v)},expression:"node.text"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }